import { render, staticRenderFns } from "./ShopsHead.vue?vue&type=template&id=116ad576&scoped=true"
import script from "./ShopsHead.vue?vue&type=script&lang=js"
export * from "./ShopsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ad576",
  null
  
)

export default component.exports